/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Uno_MessageInputs */



/**
* | output |
* | --- |
* | "I want to create a new agent. Ask me what it should do and set it up for me." |
*
* @param {Agent_Wizard_Uno_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_uno_message = /** @type {((inputs?: Agent_Wizard_Uno_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Uno_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich möchte einen neuen Agenten erstellen. Fragen Sie mich, was er tun soll, und richten Sie ihn für mich ein.")
	return /** @type {LocalizedString} */ ("I want to create a new agent. Ask me what it should do and set it up for me.")
});